'use strict';

import store from '@/store';

export default class RingtoneManager {
  constructor() {
    if (RingtoneManager.instance) {
      return RingtoneManager.instance;
    }
    RingtoneManager.instance = this;

    this.incomingChatAudioBuffer = new Audio();
    this.incomingCallAudioBuffer = new Audio();
    this.incomingEmailAudioBuffer = new Audio();
    this.incomingSmsAudioBuffer = new Audio();

    return RingtoneManager.instance;
  }

  install(Vue) {
    RingtoneManager.instance.startInteractionRingtone = this._startInteractionRingtone;
    RingtoneManager.instance.stopInteractionRingtone = this._stopInteractionRingtone;
    Vue.prototype.$ringtoneManager = RingtoneManager.instance;
  }

  _startInteractionRingtone(interaction, repeatRingtone = true) {
    if (!interaction) {
      return;
    }

    if (interaction.isTelephony) {
      this._playRingtone(
        store.getters['SETTINGS/incomingInteractionCallRingtone'],
        this.incomingCallAudioBuffer,
        repeatRingtone
      );
    } else if (interaction.isChat) {
      this._playRingtone(
        store.getters['SETTINGS/incomingInteractionChatRingtone'],
        this.incomingChatAudioBuffer,
        repeatRingtone
      );
    } else if (interaction.isEmail) {
      this._playRingtone(
        store.getters['SETTINGS/incomingInteractionEmailRingtone'],
        this.incomingEmailAudioBuffer,
        repeatRingtone
      );
    } else if (interaction.isSms) {
      this._playRingtone(
        store.getters['SETTINGS/incomingInteractionSmsRingtone'],
        this.incomingSmsAudioBuffer,
        repeatRingtone
      );
    }
  }

  _stopInteractionRingtone(stopAllRingtones = false) {
    if (store.getters['INTERACTIONS/getPendingTelephonyInteractions'].length === 0) {
      this._stopRingtone(this.incomingCallAudioBuffer);
    }
    if (store.getters['INTERACTIONS/getPendingChatInteractions'].length === 0) {
      this._stopRingtone(this.incomingChatAudioBuffer);
    }
    if (store.getters['INTERACTIONS/getPendingEmailInteractions'].length === 0) {
      this._stopRingtone(this.incomingEmailAudioBuffer);
    }
    if (store.getters['INTERACTIONS/getPendingSmsInteractions'].length === 0) {
      this._stopRingtone(this.incomingSmsAudioBuffer);
    }
    if (stopAllRingtones) {
      this._stopRingtone(this.incomingCallAudioBuffer);
      this._stopRingtone(this.incomingChatAudioBuffer);
      this._stopRingtone(this.incomingEmailAudioBuffer);
      this._stopRingtone(this.incomingSmsAudioBuffer);
    }
  }

  _stopRingtone(buffer) {
    if (buffer.isPlaying && !buffer.paused) {
      buffer.pause();
      buffer.currentTime = 0;
    }
  }

  _playRingtone(ringtone, buffer, loop) {
    if (!ringtone || !ringtone.src || buffer.isPlaying) {
      return;
    }

    buffer.src = ringtone.src;
    buffer.preload = 'auto';
    buffer.loop = loop;
    buffer.currentTime = 0;
    buffer.onloadeddata = () => {
      buffer.play();
      buffer.isPlaying = true;
    };
    buffer.onpause = () => {
      buffer.isPlaying = false;
    };
    buffer.onended = () => {
      buffer.isPlaying = false;
    };
  }
}
